export default "__VITE_ASSET__Dzje$Neq__"